// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorPage__uEDN0 {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
  background: var(--tables-main-surface);
}

.errorPageBgImage___chL7 {
  max-width: 1920px;
  height: 100%;
  object-fit: contain;
}

.errorPageBody__E56Bk {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 45px;
  flex-direction: column;
  align-items: center;
}

.errorPageIcon__W6LzL path {
  fill: var(--tables-main-surface);
}

.errorPageInfo__c30Vx {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 15px;
}

.errorPageTitle__WXlrw {
  max-width: 485px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.errorPageText__kM5ln {
  color: var(--tables-primary-row-text-additional);
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.errorPageText__kM5ln a {
  font-size: 18px;
  font-weight: 500;
  color: var(--buttons-surface);
  text-decoration: none;
}

.errorPageButtons__HQLQr {
  display: flex;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/components/Error403/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,YAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;AA1EF;;AA8EE;EACE,gCAAA;AA3EJ;;AA+EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AA5EF;;AA+EA;EACE,gBAAA;EAEA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AA7EF;;AAgFA;EACE,gDAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA9EF;AAgFE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;AA9EJ;;AAkFA;EACE,aAAA;EACA,SAAA;AA/EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.errorPage {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  background: var(--tables-main-surface);\n}\n\n.errorPageBgImage {\n  max-width: 1920px;\n  height: 100%;\n  object-fit: contain;\n}\n\n.errorPageBody {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  display: flex;\n  gap: 45px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.errorPageIcon {\n  path {\n    fill: var(--tables-main-surface);\n  }\n}\n\n.errorPageInfo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 15px;\n}\n\n.errorPageTitle {\n  max-width: 485px;\n\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  font-family: Roboto;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: uppercase;\n}\n\n.errorPageText {\n  color: var(--tables-primary-row-text-additional);\n  font-family: Roboto;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  a {\n    font-size: 18px;\n    font-weight: 500;\n    color: var(--buttons-surface);\n    text-decoration: none;\n  }\n}\n\n.errorPageButtons {\n  display: flex;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPage": `errorPage__uEDN0`,
	"errorPageBgImage": `errorPageBgImage___chL7`,
	"errorPageBody": `errorPageBody__E56Bk`,
	"errorPageIcon": `errorPageIcon__W6LzL`,
	"errorPageInfo": `errorPageInfo__c30Vx`,
	"errorPageTitle": `errorPageTitle__WXlrw`,
	"errorPageText": `errorPageText__kM5ln`,
	"errorPageButtons": `errorPageButtons__HQLQr`
};
module.exports = ___CSS_LOADER_EXPORT___;
